import { useState, useEffect } from 'react';

const CookieConsent = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            const timer = setTimeout(() => setVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent', 'accepted');
        setVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookie_consent', 'declined');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.banner}>
                <div style={styles.content}>
                    <div style={styles.iconRow}>
                        <span style={styles.icon}>🍪</span>
                        <div>
                            <p style={styles.title}>We value your privacy</p>
                            <p style={styles.text}>
                                We use cookies to improve your experience on GradeGuard.
                                You can opt out at any time.
                            </p>
                        </div>
                    </div>
                    <div style={styles.actions}>
                        <button onClick={handleDecline} style={styles.declineBtn}>
                            Decline
                        </button>
                        <button onClick={handleAccept} style={styles.acceptBtn}>
                            Accept
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        padding: '16px',
        pointerEvents: 'none',
    },
    banner: {
        maxWidth: '520px',
        margin: '0 auto',
        background: 'rgba(17, 17, 17, 0.95)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderRadius: '16px',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
        pointerEvents: 'auto',
        animation: 'slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
    },
    content: {
        padding: '20px 24px',
    },
    iconRow: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '14px',
        marginBottom: '16px',
    },
    icon: {
        fontSize: '28px',
        lineHeight: '1',
        flexShrink: 0,
        marginTop: '2px',
    },
    title: {
        color: '#fff',
        fontSize: '15px',
        fontWeight: 600,
        margin: '0 0 4px 0',
        fontFamily: "'Inter', -apple-system, sans-serif",
    },
    text: {
        color: 'rgba(255, 255, 255, 0.6)',
        fontSize: '13px',
        lineHeight: '1.5',
        margin: 0,
        fontFamily: "'Inter', -apple-system, sans-serif",
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px',
    },
    declineBtn: {
        padding: '8px 18px',
        borderRadius: '10px',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        background: 'transparent',
        color: 'rgba(255, 255, 255, 0.7)',
        fontSize: '13px',
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        fontFamily: "'Inter', -apple-system, sans-serif",
    },
    acceptBtn: {
        padding: '8px 18px',
        borderRadius: '10px',
        border: 'none',
        background: 'linear-gradient(135deg, #6C5CE7, #A855F7)',
        color: '#fff',
        fontSize: '13px',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        fontFamily: "'Inter', -apple-system, sans-serif",
    },
};

if (typeof document !== 'undefined') {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `
    @keyframes slideUp {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;
    document.head.appendChild(styleSheet);
}

export default CookieConsent;
